import { useState, useEffect } from "react";
import isOpened from "../../components/utils/isOpened";
import logo from "../../assets/images/capybar.png";

export default function Home() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    async function checkOpen() {
      const result = await isOpened();
      setOpen(result);
    }
    checkOpen();
  }, []);

  return (
    <div className="home">
      <header className="navbar">
  <div className="navbar-content">
    <nav className="nav-links">
      <a href="/">Inicio</a>
      <a href="/menu">Menú</a>
      <a href="https://www.instagram.com/capy_bar025">Contactanos</a>
    </nav>
    <div className="nav-logo">
      <img src={logo} alt="Capybar Bar" />
    </div>
  </div>
</header>

      <section className="hero">
        <img src={logo} alt="Logo Capybar Bar" className="hero-logo" />
        <h1>Bienvenidos a Capy-Bar</h1>
        <p>Sabores que te conectan.</p>
        <div className={`status ${open ? "abierto" : "cerrado"}`}>
          {open ? "Estamos Abiertos" : "Cerrado por el momento"}
        </div>
      </section>

      <section className="vision-mision">
        <div className="card vision">
          <h2>Visión</h2>
          <p>Ser reconocidos como un emprendimiento innovador y sostenible que combina sabor, creatividad y responsabilidad, proyectando a Capy-Bar como una marca con potencial de crecimiento más allá del ámbito universitario.</p>
        </div>

        <div className="card mision">
          <h2>Misión</h2>
          <p>Brindar a los consumidores una opción de comidas rápidas de calidad, accesibles y preparadas con ingredientes frescos, en un ambiente juvenil que promueva la conexión, la diversión y el bienestar.</p>
        </div>
      </section>
      <footer className="footer">
  <div className="footer-info">
    <p>© {new Date().getFullYear()} Capy-Bar. Todos los derechos reservados.</p>
    <p>Hecho con ❤️ por el equipo Capy-bar</p>
  </div>
</footer>
    </div>
  );
};

/**@copyright EmpanaStudios © 2025 */